module.exports = __webpack_public_path__ + "static/media/Ammar.6948edad.png";